import { DateObject } from "react-multi-date-picker";
import { getDateFromDatePicker } from "../utils/datepicker";

export interface productType {
    key: number,
    id: number,
    code?: string,
    name: string,
    remark?: string,
    status?: number,
    products_count?: number,
    create_date?: string,
}

export const initProductType: productType = {
    key: 0,
    id: 0,
    code: "",
    name: "",
    remark: "",
    status: 1,
    products_count: 0,
    create_date: "",
}

export interface productUnit {
    key: number,
    id: number,
    code?: string,
    name: string,
    symbol?: string,
    remark?: string,
    status?: number,
    products_count?: number,
    create_date?: string,
}

export const initProductUnit: productUnit = {
    key: 0,
    id: 0,
    code: "",
    name: "",
    symbol: "",
    remark: "",
    status: 1,
    products_count: 0,
    create_date: "",
}

export interface unitType extends productUnit {}
export const initUnitType = initProductUnit;

export interface vat {
    key: number,
    id: number,
    name: string,
}

export interface vendor {
    key: number,
    id: number,
    code: string,
    name: string,
    tax_id?: string,
    tel?: string,
    fax?: string,
    email?: string,
    address?: string,
    remark?: string,
}

export const initVendor = {
    key: 0,
    id: 0,
    code: "",
    name: "",
    tax_id: "",
    tel: "",
    fax: "",
    email: "",
    address: "",
    remark: "",
}

export interface product {
    key: number,
    id: number,
    product_code: string,
    product_name: string,
    product_name_other?: string,
    product_type?: number,
    product_type_name?: string,
    product_unit?: number,
    product_unit_name?: string,
    quantity?: number,
    weight?: number,
    product_normal_type?: number,
    product_cost?: string | number,
    price?: number,
    price_retail?: number | string,
    price_wholesale?: number | string,
    price_retail_member?: number | string,
    price_wholesale_member?: number | string,
    init_order_amount?: string | number,
    point_purchase?: string | number,
    limit_quantity?: string | number,
    vat?: number,
    point?: string | number,
    is_cut_stock?: number,
    is_tier_price?: number,
    is_avg_cost?: number,
    expire_date?: string,
    vendor?: any,
    vendor_name?: string,
    remark?: string,
    status?: number,
    tier_price?: string,
}

export const initProduct = {
    key: 0,
    id: 0,
    product_code: "",
    product_name: "",
    product_name_other: "",
    product_type: 0,
    product_type_name: "",
    product_unit: 0,
    product_unit_name: "",
    quantity: 1,
    weight: 0,
    product_normal_type: 1,
    product_cost: "",
    price: 0,
    price_retail: 0,
    price_wholesale: 0,
    price_retail_member: 0,
    price_wholesale_member: 0,
    init_order_amount: "",
    point_purchase: "",
    limit_quantity: "",
    vat: -1,
    point: "",
    is_cut_stock: 0,
    is_tier_price: 0,
    is_avg_cost: 0,
    expire_date: getDateFromDatePicker(new DateObject()),
    vendor: [],
    vendor_name: "",
    remark: "",
    status: 1,
    tier_price: '[]'
}

export interface employee {
    key: number,
    id: number,
    code: string,
    username?: string,
    password?: string,
    name: string,
    first_name?: string,
    last_name?: string,
    prefix?: string,
    tel?: string,
    email?: string,
    address?: string,
    is_active?: number | boolean,
    use_shift?: number | boolean,
    role?: 'manager' | 'cashier' | 'custom' | string,
    action_permissions?: string[],
    menu_permissions?: string[],
    permissions?: string[],
    image?: string,
    privilege?: number,
    status: number,
    create_date: string
}

export const initEmployee: employee = {
    key: 0,
    id: 0,
    // Every field below carried a working demo identity: code, username
    // AND password all "admin", a manager's name, a phone number and an
    // email. Opening "add employee" and pressing save created a real
    // account with the password `admin` -- since 7C-1 hashes passwords,
    // a real, usable one. A blank form is what an empty form should be;
    // `name`, `tel` and `password` are required on INSERT anyway.
    code: "",
    username: "",
    password: "",
    name: "",
    first_name: "",
    last_name: "",
    prefix: "",
    tel: "",
    email: "",
    address: "",
    is_active: 1,
    use_shift: 0,
    role: "cashier",
    action_permissions: [
        "sale",
        "apply_discount",
        "hold_bill",
        "cancel_sale",
        "edit_items",
        "delete_items",
        "open_drawer",
        "work_shift",
        "shortcut",
        "print_receipt"
    ],
    menu_permissions: [
        "sale",
        "product",
        "check_stock",
        "good_receive",
        "separate",
        "include",
        "withdraw",
        "member",
        "member_group",
        "vendor",
        "employee",
        "product_type",
        "product_unit",
        "payment_type",
        "expense",
        "config_general",
        "config_separate",
        "report"
    ],
    permissions: [
        "sale", "apply_discount", "hold_bill", "cancel_sale", "edit_items",
        "delete_items", "open_drawer", "work_shift", "shortcut", "print_receipt",
        "product", "purchase_order", "good_receive", "check_stock", "separate", "include", "withdraw",
        "member", "member_group", "vendor", "employee", "product_type", "product_unit",
        "payment_type", "expense", "config_general", "config_separate", "report"
    ],
    privilege: 2,
    status: 1,
    create_date: ""
}

export interface saleType {
    key: number,
    id: number,
    name: string,
}

export const initSaleType = {
    key: 0,
    id: 0,
    name: "",
}

export interface paymentType {
    key: number,
    id: number,
    code: string,
    name: string,
    remark?: string,
    status?: number,
    create_date?: string,
}

export const initPaymentType: paymentType = {
    key: 0,
    id: 0,
    code: "",
    name: "",
    remark: "",
    status: 1,
    create_date: "",
}